<template>
  <div>
    <div class="form" v-if="showDetail">
      <div class="form-item">
        <div class="form-title">
          <div>区域预授信企业明细表</div>
          <el-button style="font-weight: bold; font-size: 16px; padding: 0;" type="text" icon="el-icon-back" @click="backList">
            返回列表
          </el-button>
        </div>
        <div style="padding: 20px;">
          <el-table border :data="companyData" style="width: 100%" max-height="600">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="apply_date" label="申请日期">
              <template slot-scope="scope">
                <span>{{ formatDateTime(scope.row.apply_date) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="repeat_num" label="是否重合">
              <template slot-scope="scope">
                <span>{{ scope.row.repeat_num > 0 ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="company_name" label="企业名称" width="250"></el-table-column>
            <el-table-column prop="company_credit_code" label="统一社会信用代码" width="200"></el-table-column>
            <el-table-column prop="apply_user_tel" label="申请人"></el-table-column>
            <el-table-column prop="product_name" label="产品类型"></el-table-column>
            <el-table-column prop="credit_amt" label="预授信额度"></el-table-column>
            <el-table-column prop="province_name" label="所在省份"></el-table-column>
            <el-table-column prop="city_name" label="所在城市"></el-table-column>
            <el-table-column prop="area_name" label="所在区域"></el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :page-sizes="[50, 100, 200, 300]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="rpt-content" v-else>
      <div style="margin-bottom: 20px;">
        <!-- <el-date-picker
          class="search-control-item"
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        ></el-date-picker> -->
        <!-- <el-select class="search-control-item" v-model="productType" placeholder="请选择产品类型">
          <el-option label="全部" value="0"></el-option>
          <el-option label="进出口易贷" value="1"></el-option>
        </el-select> -->
        <region class="search-control-item" v-model="regionId" />
        <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="searchRegion">查询</el-button>
      </div>
      <el-table
        lazy
        v-loading="tableloading"
        @row-dblclick="rowDblclick"
        :load="loadData"
        :data="regionData"
        style="width: 100%"
        :tree-props="{ children: 'children', hasChildren: 'children' }"
        row-key="code"
      >
        <el-table-column prop="name" label="省份"></el-table-column>
        <el-table-column label="企业数(家)">
          <el-table-column prop="total_ysx_company" label="数量"></el-table-column>
          <el-table-column prop="" label="环比增长率（%）"></el-table-column>
        </el-table-column>
        <el-table-column prop="total_ysx_amt" label="预授信总金额"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'province',
  data() {
    return {
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      companyData: [],

      province_id: null,
      city_id: null,
      area_id: null,
      selectRegion: null,

      showDetail: false,
      tableloading: false,
      regionId: [],
      cityList: [],
      productType: '',
      date: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/1/1`);
              picker.$emit('pick', [start, now]);
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const now = new Date();
              const end = new Date(now.setDate(0));
              console.log(end);
              const start = new Date(`${end.getFullYear()}/${end.getMonth() + 1}/1`);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/${now.getMonth() + 1}/1`);
              picker.$emit('pick', [start, now]);
            }
          }
        ]
      },
      regionData: [],
      mapData: []
    };
  },
  async mounted() {
    this.tableloading = true;
    // 获取城市数据

    let region = await this.$axios('./region/region.json');
    let data = await request({
      url: `/api/rpt/area?id=100000&level=0`
    });
    this.mapData = region.data;
    this.regionData = this.addTableData(region.data, data.result);

    this.tableloading = false;
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.search();
    },
    // 搜索城市内企业列表
    search() {
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      if (this.area_id) {
        data.area_id = this.selectRegion;
      } else if (this.city_id) {
        data.city_id = this.selectRegion;
      } else {
        data.province_id = this.selectRegion;
      }
      request({ url: `/api/rpt/company/ysx/detail`, data }).then(res => {
        if (res.success) {
          this.companyData = res?.result?.companyYSXList;
          this.total = res?.result?.recordCount;
        }
      });
    },

    // 搜索树形企业数据
    searchRegion() {
      let code = this.regionId[this.regionId.length - 1];
      request({ url: `/api/rpt/area?id=${code}&level=${this.regionId.length}` }).then(res => {
        console.log(res);
        if (res.success) {
          if (this.regionId.length > 0) {
            this.cityList = [];
            this.findChildren(this.mapData, this.regionId[0], 1);
            console.log(this.cityList);
            this.regionData = this.addTableData(this.cityList, res.result);
          }
        }
      });
    },
    findChildren(region, code, level) {
      for (let i = 0; i < region.length; i++) {
        if (code == region[i].code) {
          if (level < this.regionId.length) {
            this.findChildren(region[i].children, this.regionId[level], level + 1);
          } else {
            this.cityList = region[i].children;
          }
        }
      }
    },

    // 显示区域预授信企业明细
    rowDblclick(row) {
      let { area, city, province, code } = row;
      this.area_id = area;
      this.city_id = city;
      this.province_id = province;
      this.selectRegion = code;
      this.search();
      this.showDetail = true;
    },
    // 树形懒加载数据
    loadData(row, treeNode, resolve) {
      let level = row.city ? 2 : 1;
      request({
        url: `/api/rpt/area?id=${row.code}&level=${level}`,
        method: 'get'
      }).then(res => {
        resolve(this.addTableData(row.children, res.result));
      });
    },
    // 返回列表
    backList() {
      this.area_id = null;
      this.city_id = null;
      this.province_id = null;
      this.selectRegion = null;
      this.showDetail = false;
    },
    // 循环进行数据插入数组
    addTableData(region, data) {
      region.forEach(item => {
        item.total_ysx_company = 0;
        item.total_ysx_amt = 0;
        for (let i = 0; i < data.length; i++) {
          if (item.code == data[i].area_id) {
            item.total_ysx_company = data[i].total_ysx_company;
            item.total_ysx_amt = data[i].total_ysx_amt;
            break;
          }
        }
      });
      return region;
    }
  }
};
</script>

<style></style>
